/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useCallback,
  useMemo,
} from 'react';
import {
  Row,
  Col,
} from 'antd';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';

import { getGanttColumns } from './ganttScheduleHelpers';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

export default function GanttScheduleColumnsSection(props) {
  const {
    visibleColumns,
    setVisibleColumns,
  } = props;

  const { t } = useTranslation();

  const ganttColumns = useMemo(() => getGanttColumns(true), []); // Always show project column

  const visibleColumnSet = useMemo(() => new Set(visibleColumns), [visibleColumns]);

  const onChange = useCallback((key) => (checked) => {
    const newVisibleColumns = [...visibleColumns];
    if (checked) {
      newVisibleColumns.push(key);
    } else {
      const index = newVisibleColumns.indexOf(key);
      if (index > -1) {
        newVisibleColumns.splice(index, 1);
      }
    }
    setVisibleColumns(newVisibleColumns);
  }, [visibleColumns]);

  const onDragEnd = useCallback((result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const {
      source: {
        index: sourceIndex,
      },
      destination: {
        index: destinationIndex,
      },
    } = result;

    const newVisibleColumns = [...visibleColumns];
    const tempRow = newVisibleColumns[destinationIndex];
    newVisibleColumns[destinationIndex] = newVisibleColumns[sourceIndex];
    newVisibleColumns[sourceIndex] = tempRow;
    setVisibleColumns(newVisibleColumns);
  }, [visibleColumns]);

  return (
    <>
      <h3>Visible Columns</h3>
      <p>Please select the columns you would like visible in the gantt schedule</p>
      <Row>
        {ganttColumns.map((column) => (
          <Col span={8} key={column}>
            <OnTraccrCheckbox
              style={{ marginTop: 5 }}
              onChange={onChange(column)}
              value={visibleColumnSet.has(column)}
              label={column === 'Project' ? t('Project') : column}
            />
          </Col>
        ))}
      </Row>
      <br />
      <br />
      <h3>Column Order</h3>
      <p>Drag and drop the columns to change the order</p>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {({ innerRef: dropRef, droppableProps }) => (
            <div
              {...droppableProps}
              ref={dropRef}
            >
              <ol>
                {visibleColumns.map((column, index) => (
                  <Draggable key={column} draggableId={column} index={index}>
                    {({ draggableProps, dragHandleProps, innerRef: dragRef }) => (
                      <li
                        ref={dragRef}
                        {...draggableProps}
                        {...dragHandleProps}
                        style={{
                          ...draggableProps.style,
                        }}
                      >
                        {column === 'Project' ? t('Project') : column}
                      </li>
                    )}
                  </Draggable>
                ))}
              </ol>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
}

GanttScheduleColumnsSection.propTypes = {
  visibleColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  setVisibleColumns: PropTypes.func.isRequired,
  isMaster: PropTypes.bool.isRequired,
};
